<template>
    <div class="animal-groups">
        <div class="group-list">
            <div v-for="group in items" :key="group.id" class="group-item">
                <div class="group-field-name">
                    <div class="group-field group-field-title"> {{ group.name }}</div>
                    <v-btn :disabled="!hasPermission('group', 'change')" icon @click="onSelect(group)">
                        <v-icon font-size="1" icon="cog"></v-icon>
                    </v-btn>
                </div>
                <div class="group-field">
                    <div>{{ 'base.animal_type' | translate }}:</div>
                    <div>{{ getAnimalTypeName(group) | shortstr }}</div>
                </div>
                <div class="group-field animals-count">
                    <div>{{ 'base.animal_count' | translate }}:</div>
                    <ui-number-input :disabled="!hasPermission('group', 'change')" @input="updateGroupAnimalCount(group, $event)" v-model="group.animal_count" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import UiNumberInput from '@/components/ui/ui-number-input/UiNumberInput.vue'
import paginationMixin from '@/mixins/pagination.mixin'
import api from '@/api'
export default {
  name: 'GroupsMobile',

  mixins: [paginationMixin],

  data: () => ({
    selected: null
  }),

  mounted () {
    this.setupPagination(
      api.groups.list,
      { farm: this.$route.params.farm_id },
      `farm_${this.$route.params.farm_id}_groups`
    )
  },
  methods: {
    onSelect (group) {
      this.$emit('select', group)
    },
    getAnimalTypeName (item) {
      return item.animal_type
        ? item.animal_type.name
        : '-'
    },
    updateGroupAnimalCount (group, newCount) {
      const { id, ...payload } = group
      payload.animal_count = newCount
      api.groups.updateById(id, payload)
    }
  },

  components: {
    UiNumberInput
  },

  computed: {
    allowView () {
      return this.hasPermission('group', 'view')
    }
  }
}
</script>
<style scoped>
.animal-groups {
    font-family: Arial, sans-serif;
    max-width: 800px;
    margin: 0 auto;
}

.group-list {
    border-radius: 4px;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    gap: 20px;

}

.group-field-name {
    width: 100%;
    display: flex;
    justify-content: space-between;
}


.group-item {
    display: flex;
    padding: 10px;
    background: white;
    border-radius: 1rem;
}



.group-field {
    flex: 1;
    padding: 0 5px;
    color: #000;
    font-size: 1.5rem;
    font-weight: 500;
    border-top: .1rem solid #e2e2e2;
    padding: 1rem 1.5rem 1rem 0;
    display: flex;
    justify-content: space-between;
}

.group-field:first-child {
    border: unset;
}

.group-field-title {
    font-size: 1.6rem;
    font-weight: 400;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 25rem;
    font-family: "Museo Sans", sans-serif;
    color: #000;
}

.animals-count {
    color: #000;
}

.group-item {
    flex-wrap: wrap;
}

.group-field {
    flex-basis: 100%;
    font-family: "Museo Sans", sans-serif;
}
</style>